import { render, staticRenderFns } from "./PasswordRecoveryForm.vue?vue&type=template&id=48428665&"
import script from "./PasswordRecoveryForm.vue?vue&type=script&lang=ts&"
export * from "./PasswordRecoveryForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VTextField})
